

export enum KalturaEntryApplication {
    kaf = '2',
	kalturaMeeting = '7',
	kmc = '0',
	kms = '1',
	kmsGo = '4',
	personalCapture = '6',
	pitch = '3',
	webcastApp = '5'
}